import { Component } from '@angular/core';
import { ExportOptionsHelper } from '../helpers/export-options-helper';

export const OPTIONS = [
  {
    display: $localize`Remote-IDs entfernen`,
    key: 'removeRemoteIds',
    description: $localize`Sollten nur in Ausnahmefällen nicht entfernt werden!`,
  },
];

@Component({
  templateUrl: './export-options-popover.page.html',
})
export class ExportOptionsPopoverPage {
  _options = OPTIONS;

  constructor(public readonly exportOptionsHelper: ExportOptionsHelper) {}
}
